/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 사용자, 관리자 레이아웃을 나누고 라우터를 분배하는 컴포넌트
 * 버전 : 1.0
 * 파일명 : AppContent.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * 수정 : 2025-07-02, 강동형 : 저작권 추가, 오늘의 홍보 학교 페이지 라우트 추가
 * ================================================================ 
 * 수정 : 2025-07-04, 강동형 : 홍보 대상 추가 페이지 라우트 추가
 * 수정 : 2025-07-08, 강동형 : 홍보 대상 추가 페이지 라우트 삭제
 * ================================================================ */
import { Routes, Route} from 'react-router-dom';
import LoginPage from './pages/LoginPage/LoginPage';
import HomePage from './pages/HomePage';
import SignUp from './pages/LoginPage/SignUpPage';
import SignUpDetails from './pages/LoginPage/SignUpDetailsPage';
import SignUpDeny from './pages/LoginPage/SignUpDenyPage';
import FindingIdPage from './pages/LoginPage/FindingIdPage';
import FindingPasswordPage from './pages/LoginPage/FindingPasswordPage';
import RecruitmentPage from './pages/RecruitmentPage';
import SchoolSearchPage from './pages/SchoolSearchPage';
import PromoResultPage from './pages/PromoResultPage';
import InterestedPage from './pages/InterestedPage';
import MyInfo from './pages/MyInfo';
import UserLayout from './layouts/UserLayout';
import AdminLayout from './layouts/AdminLayout';
import AdLoginPage from './pages/AdminPage/AdLoginPage';
import AdAccountPage from './pages/AdminPage/AdAccountPage';
import AdRecruitPage from './pages/AdminPage/AdRecruitPage';
import AdPromoPage from './pages/AdminPage/AdPromoPage';
import AdAchivePage from './pages/AdminPage/AdAchivePage';
import AdUserInfoPage from './pages/AdminPage/AdUserInfoPage';
import TodaysPromoPage from './pages/TodaysPromoPage';
import AdTeamPage from './pages/AdminPage/AdTeamPage';

function AppContent() {
  return (
    <Routes>
      <Route element={<UserLayout />}>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signup-details" element={<SignUpDetails />} />
        <Route path="/signup-deny" element={<SignUpDeny />} />
        <Route path="/find-username" element={<FindingIdPage />} />
        <Route path="/find-password" element={<FindingPasswordPage />} />
        <Route path="/recruitment" element={<RecruitmentPage />} />
        <Route path="/searching-promotion-school" element={<SchoolSearchPage />} />
        <Route path="/promotion-result-list" element={<PromoResultPage />} />
        <Route path="/interested-person-management" element={<InterestedPage />} />
        <Route path="/my-info" element={<MyInfo />} />
        <Route path="/todays-promotion" element={<TodaysPromoPage />} />
      </Route>
      <Route path ='/admin' element={<AdminLayout/>}>
        <Route index element={<AdLoginPage />} />
        <Route path="account" element={<AdAccountPage />} />
        <Route path="recruit" element={<AdRecruitPage />} />
        <Route path="promo" element={<AdPromoPage />} />
        <Route path="achive" element={<AdAchivePage />} />
        <Route path="userinfo" element={<AdUserInfoPage />} />
        <Route path="team" element={<AdTeamPage />} />
      </Route>
    </Routes>
  );
}

export default AppContent;
